<template>
  <v-container fluid class="pt-1 pa-0">
    <v-row dense>
      <v-col
        v-if="$vuetify.breakpoint.smAndUp"
        cols="12"
        sm="4"
        :md="twoColumn ? null : 3"
        :xl="twoColumn ? 3 : 2"
        class="left-column d-flex flex-column"
        style="gap: 12px"
      >
        <slot name="left">
          <span>Default Left Section</span>
        </slot>
        <slot v-if="$vuetify.breakpoint.smOnly" name="right">
          <span>Default Right Section</span>
        </slot>
      </v-col>
      <v-col
        class="main-column"
        cols="12"
        sm="8"
        :md="twoColumn ? null : 6"
        :xl="twoColumn ? 9 : 8"
      >
        <slot name="main">
          <span>Default Main Section</span>
        </slot>
      </v-col>
      <v-col
        v-if="!twoColumn"
        cols="12"
        sm="4"
        md="3"
        xl="2"
        class="right-column align-self-start"
      >
        <slot name="right">
          <!-- <span>Default Right Section</span> -->
        </slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ThreeColumnLayout",
  props: {
    dense: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    twoColumn() {
      return this.deviceSize.tablet;
    },
  },
};
</script>
